import { render, staticRenderFns } from "./coderProResponses.vue?vue&type=template&id=06b5bb0c&scoped=true&"
import script from "./coderProResponses.vue?vue&type=script&lang=js&"
export * from "./coderProResponses.vue?vue&type=script&lang=js&"
import style0 from "./coderProResponses.vue?vue&type=style&index=0&id=06b5bb0c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06b5bb0c",
  null
  
)

export default component.exports